import { SignIn, SignUp } from "@clerk/react";

function AuthShell({ children }) {
  return (
    <div data-testid="auth-page" className="min-h-screen flex bg-background">
      <div className="hidden lg:flex flex-1 flex-col justify-between p-12 bg-stone-900 text-[#FAF8F5] relative overflow-hidden">
        <p className="font-serif text-2xl">Becoming</p>
        <div className="max-w-md">
          <h1 className="font-serif text-5xl leading-tight tracking-tight">
            A living archive of what you're <em className="italic text-blue-300">becoming</em>.
          </h1>
          <p className="mt-6 text-sm leading-relaxed text-stone-300">
            Capture what you explore, understand it, watch connections appear — and turn real work into achievements
            worth showing.
          </p>
        </div>
        <p className="text-xs text-stone-500">Private by default. Yours forever.</p>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">{children}</div>
    </div>
  );
}

export function SignInPage() {
  return (
    <AuthShell>
      <SignIn
        routing="path"
        path="/sign-in"
        signUpUrl="/sign-up"
        withSignUp
      />
    </AuthShell>
  );
}

export function SignUpPage() {
  return (
    <AuthShell>
      <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
    </AuthShell>
  );
}
